import { hotjarId, hotjarSv } from "config/environment";

export const hotjarConfig = {
  hjid: hotjarId,
  hjsv: hotjarSv,
};
